/* eslint-disable react/jsx-props-no-spreading */
import { LoadingComponent } from "@iventis/components";
import { LoadableComponent } from "@loadable/component";
import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useCheckUserLoggedIn } from "@iventis/permissions/src/use-check-user-logged-in";

// A route accessible by any user only if they are not authenticated
const PublicRouteWithRedirect: React.FC<{
    component: React.FC | LoadableComponent<unknown>;
    path: string;
    exact?: boolean;
}> = ({ component: Component, ...rest }) => {
    const [isAuthenticated, loadingUser] = useCheckUserLoggedIn();
    const { search } = useLocation();

    if (loadingUser) {
        return <LoadingComponent />;
    }
    const urlParams = new URLSearchParams(search);
    const redirectUrl = urlParams.get("redirectUrl");
    // Validate the redirect URL by resolving it against the current origin and confirming the origins match.
    // This prevents open redirect and reflected XSS attacks (e.g. javascript: URIs, protocol-relative URLs,
    // encoded bypasses such as %2F%2F, and backslash-relative paths like /\example.com).
    // The resolved href is used in the redirect to avoid normalization discrepancies between validation and use.
    const safeRedirectHref = (() => {
        if (redirectUrl == null) return null;
        try {
            const resolved = new URL(redirectUrl, window.location.origin);
            return resolved.origin === window.location.origin ? resolved.href : null;
        } catch {
            return null;
        }
    })();
    if (isAuthenticated && safeRedirectHref != null) {
        window.location.replace(safeRedirectHref); // Using this instead of the redirect below to avoid odd state. it was causing the map not to load sometimes.
    }
    // eslint-disable-next-line react/no-unstable-nested-components
    return <Route {...rest} component={(props) => (isAuthenticated ? <Redirect to="/" /> : <Component {...props} />)} />;
};

export default PublicRouteWithRedirect;
